import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPlus } from '@fortawesome/free-solid-svg-icons';
import { useState } from "react";
import { useParams } from 'react-router';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';
import { useNavigate } from 'react-router';

function ProjectKpiView() {
    const columns = [
        { name: "السؤال", key: "quiz" },
        { name: " الحالة", key: "status" },
        { name: "", key: "actions" },
    ];
    const navigate = useNavigate();
    const { id } = useParams();
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());
  
   
  
   

    


    const dropdownOptions = [
        { label: "حذف", action: (id) => {
            if (window.confirm("هل أنت متأكد من حذف هذا المؤشر")) {
                API.get(`/projectkpi/${id}/delete`)
                    .then((res) => {
                        if (res.status === 200) {
                           setTableReloadKey(Date.now());
                        }
                    })
                    .catch((error) => {
                        console.error("There was an error!", error);
                    });
            }
        } },
    ];

    return (
        <>
            <div className="printcasedata-container">

                <div className="archive-report">
                    <span className="add-row-ta archiveAdd" onClick={() => navigate(`/projectkpis/${id}`)}>
                        <FontAwesomeIcon icon={faPlus} /> إضافة
                    </span>
                </div>

                <TableComponent
                    apiUrl={`/projectkpi/${id}`}
                    columns={columns}
                    title=" مؤشرات الاداء"
                    dropdownOptions={dropdownOptions}
                    search={false}
                    triggerReload={tableReloadKey}
                />
            </div>

        </>
    );
}

export default ProjectKpiView;
